var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#cecdcd;stroke-width:0.5px;}.cls-3{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.34,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.5,
    y1: -18.8,
    x2: -19.41,
    y2: 24.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.48,
    y1: -12.82,
    x2: -13.43,
    y2: 30.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.47,
    y1: -6.83,
    x2: -7.44,
    y2: 36.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 41.46,
    y1: -0.85,
    x2: -1.46,
    y2: 42.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 47.44,
    y1: 5.14,
    x2: 4.53,
    y2: 48.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.43,
    y1: 11.12,
    x2: 10.52,
    y2: 54.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.41,
    y1: 17.11,
    x2: 16.5,
    y2: 60.02
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripes);
export default __webpack_public_path__ + "static/media/stripes.7bcc6007a55bded46f13afaaa593fe58.svg";
export { ForwardRef as ReactComponent };